import { render, staticRenderFns } from "./ValidationModal.vue?vue&type=template&id=2dc57996&scoped=true&"
import script from "./ValidationModal.vue?vue&type=script&lang=js&"
export * from "./ValidationModal.vue?vue&type=script&lang=js&"
import style0 from "./ValidationModal.vue?vue&type=style&index=0&id=2dc57996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc57996",
  null
  
)

export default component.exports